import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';


export const Container = styled.div`
  grid-area: estimate;
  margin: 0 0 0 -45px;
  position: relative;
  align-items: center;
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 0 0 0 0;
    padding-left: 30px;
  }
`;

export const Wrapper = styled.div`
  //grid-area: estimate;
  margin: 15px 0 0 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  justify-content: center;
  
  @media (min-width: ${breakpoints.desktop}) {
    align-items: center;
    text-align: left;  
    margin: 0 0px;
    justify-content: flex-start;
  }
`;

export const EstimateValueWrapper = styled.div`
  justify-content: center;
  align-items: center;
  width: auto;

  @media (min-width: ${breakpoints.desktop}) {
  width: auto;
  }
`;

export const EstimateTitle = styled.h3`

  text-align: left;
  font-weight: normal;
  font-family: 'Roboto', sans-serif;
  margin: 0;
  font-size: 1rem;
  
  @media (min-width: ${breakpoints.desktop}) {

  }
`;

export const EstimateValue = styled.h3`
  color: white;
  text-align: left;
  font-weight: lighter;
  margin: 5px 0 0 0;
  font-size: 4.2rem;
  
  @media (min-width: ${breakpoints.desktop}) {
    font-weight: 500;
    margin: 0;
    font-size: 6rem;
  }
  
`;

export const ValueMeterWrapper = styled.div`
  position: relative;
  margin: 5px;
  width: auto;
`;

export const ValueMeter = styled.img`
  border: 0;
  height: 120px;
  max-width: none;
`;

export const UpperValue = styled.p`
  margin: 0;
  color: #1cb723;
  position: absolute;
  top: 0;
  left: 30px;
  font-size: 1rem;
`;

export const LowerValue = styled.p`
  margin: 0;
  color: #ea0709;
  position: absolute;
  bottom: 0;
  left: 30px;
  font-size: 1rem;
`;

export const NoDataWrapper = styled.div`
  padding: 10px;
  grid-area: estimate;
  display: flex;
  flex-direction: row;
  margin: 0 0 25px 0;
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 0 0 0 25px;
  }
`;

export const NoDataText = styled.p`
  color: #bfbfbf;
  text-align: left;
  font-size: 18px;
  justify-content: center;
  align-items: center;
  display: flex;
  margin-left: 15px;
  line-height: 26px;
`;

export const NoDataIcon = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
`;
